import { render, staticRenderFns } from "./Reaction.vue?vue&type=template&id=7c4349d6&scoped=true&"
import script from "./Reaction.vue?vue&type=script&lang=js&"
export * from "./Reaction.vue?vue&type=script&lang=js&"
import style0 from "./Reaction.vue?vue&type=style&index=0&id=7c4349d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4349d6",
  null
  
)

export default component.exports